console.log("BASIC Configurator loading...");

// Hintamuutokset
const PRICE_ADJUSTMENTS = {
  euroAdjustment: 0,      // Euromääräinen lisäys/vähennys
  percentAdjustment: 8    // Prosentuaalinen lisäys/vähennys
};

// Määritä konfiguraatio
window.BasicProductConfig = {
  variantIds: {
    base: 51824389685586,
    adjustment: 51813495931218
  },
  dimensions: {
    minWidth: 200,
    maxWidth: 1500,
    minHeight: 200,
    maxHeight: 2200,
    maxArea: 2.6,
  },
  profiles: {
    white9016: { name: "Valkoinen RAL9016", color: "#FFFFFF" },
    white9016structure: {
      name: "Valkoinen RAL9016 structure",
      color: "#F8F8F8",
    },
    white9010structure: {
      name: "Valkoinen RAL9010 structure",
      color: "#F1F1F1",
    },
    silverAnodized: { name: "Hopea anodisoitu E6/EV1", color: "#EDEDED" },
    lightGray7040: {
      name: "Vaaleanharmaa RAL7040 structure",
      color: "#C0C0C0",
    },
    darkGrayDB703: { name: "Tummanharmaa DB 703", color: "#575556" },
    black9005structure: { name: "Musta RAL9005 structure", color: "#0A0A0A" },
  },

  priceTable: {
    S: {
      700: {
        400: 74,
        500: 78,
        600: 83,
        700: 96,
        800: 103,
        900: 116,
        1000: 123,
        1100: 130,
        1200: 142,
        1300: 150,
        1400: 158,
        1500: 168,
        1600: 176,
      },
      800: {
        400: 75,
        500: 80,
        600: 85,
        700: 97,
        800: 105,
        900: 118,
        1000: 126,
        1100: 134,
        1200: 147,
        1300: 155,
        1400: 161,
        1500: 172,
        1600: 180,
      },
      900: {
        400: 78,
        500: 83,
        600: 89,
        700: 102,
        800: 111,
        900: 123,
        1000: 132,
        1100: 140,
        1200: 153,
        1300: 160,
        1400: 170,
        1500: 180,
        1600: 189,
      },
      1000: {
        400: 81,
        500: 85,
        600: 94,
        700: 106,
        800: 116,
        900: 128,
        1000: 138,
        1100: 146,
        1200: 159,
        1300: 168,
        1400: 177,
        1500: 188,
        1600: 197,
      },
      1100: {
        400: 83,
        500: 89,
        600: 96,
        700: 110,
        800: 120,
        900: 133,
        1000: 143,
        1100: 152,
        1200: 166,
        1300: 175,
        1400: 185,
        1500: 196,
        1600: 205,
      },
      1200: {
        400: 87,
        500: 93,
        600: 100,
        700: 115,
        800: 124,
        900: 138,
        1000: 147,
        1100: 157,
        1200: 173,
        1300: 183,
        1400: 193,
        1500: 203,
        1600: 214,
      },
      1300: {
        400: 91,
        500: 95,
        600: 104,
        700: 119,
        800: 129,
        900: 143,
        1000: 153,
        1100: 164,
        1200: 178,
        1300: 189,
        1400: 199,
        1500: 211,
        1600: 223,
      },
      1400: {
        400: 93,
        500: 98,
        600: 108,
        700: 122,
        800: 133,
        900: 147,
        1000: 157,
        1100: 170,
        1200: 185,
        1300: 196,
        1400: 207,
        1500: 219,
        1600: 230,
      },
      1500: {
        400: 96,
        500: 101,
        600: 111,
        700: 126,
        800: 137,
        900: 153,
        1000: 164,
        1100: 175,
        1200: 192,
        1300: 203,
        1400: 215,
        1500: 227,
        1600: 239,
      },
      1600: {
        400: 98,
        500: 104,
        600: 115,
        700: 131,
        800: 143,
        900: 156,
        1000: 170,
        1100: 182,
        1200: 198,
        1300: 209,
        1400: 220,
        1500: 235,
        1600: 246,
      },
      1700: {
        400: 101,
        500: 108,
        600: 119,
        700: 135,
        800: 148,
        900: 162,
        1000: 175,
        1100: 187,
        1200: 204,
        1300: 217,
        1400: 229,
        1500: 242,
        1600: 256,
      },
      1800: {
        400: 104,
        500: 112,
        600: 122,
        700: 139,
        800: 152,
        900: 168,
        1000: 181,
        1100: 193,
        1200: 210,
        1300: 225,
        1400: 237,
        1500: 251,
        1600: 265,
      },
      1900: {
        400: 107,
        500: 114,
        600: 125,
        700: 143,
        800: 155,
        900: 172,
        1000: 185,
        1100: 199,
        1200: 217,
        1300: 231,
        1400: 243,
        1500: 258,
        1600: 273,
      },
      2000: {
        400: 109,
        500: 117,
        600: 130,
        700: 147,
        800: 161,
        900: 177,
        1000: 190,
        1100: 205,
        1200: 224,
        1300: 237,
        1400: 251,
        1500: 266,
        1600: 281,
      },
      2100: {
        400: 113,
        500: 120,
        600: 134,
        700: 151,
        800: 165,
        900: 182,
        1000: 196,
        1100: 211,
        1200: 230,
        1300: 243,
        1400: 259,
        1500: 274,
        1600: 287,
      },
      2200: {
        400: 116,
        500: 123,
        600: 138,
        700: 154,
        800: 170,
        900: 188,
        1000: 202,
        1100: 216,
        1200: 236,
        1300: 252,
        1400: 265,
        1500: 282,
        1600: 297,
      },
      2300: {
        400: 119,
        500: 127,
        600: 141,
        700: 160,
        800: 174,
        900: 192,
        1000: 208,
        1100: 223,
        1200: 242,
        1300: 259,
        1400: 274,
        1500: 291,
        1600: 304,
      },
      2400: {
        400: 121,
        500: 129,
        600: 144,
        700: 163,
        800: 180,
        900: 197,
        1000: 213,
        1100: 229,
        1200: 250,
        1300: 264,
        1400: 281,
        1500: 299,
        1600: 314,
      },
    },
    0: {
      700: {
        400: 81,
        500: 85,
        600: 92,
        700: 102,
        800: 113,
        900: 128,
        1000: 145,
        1100: 155,
        1200: 166,
        1300: 177,
        1400: 188,
        1500: 198,
        1600: 209,
      },
      800: {
        400: 83,
        500: 88,
        600: 95,
        700: 107,
        800: 117,
        900: 131,
        1000: 139,
        1100: 147,
        1200: 162,
        1300: 170,
        1400: 179,
        1500: 190,
        1600: 199,
      },
      900: {
        400: 86,
        500: 92,
        600: 97,
        700: 112,
        800: 122,
        900: 135,
        1000: 145,
        1100: 154,
        1200: 168,
        1300: 178,
        1400: 187,
        1500: 199,
        1600: 208,
      },
      1000: {
        400: 90,
        500: 94,
        600: 102,
        700: 116,
        800: 126,
        900: 141,
        1000: 151,
        1100: 161,
        1200: 176,
        1300: 186,
        1400: 195,
        1500: 207,
        1600: 217,
      },
      1100: {
        400: 93,
        500: 98,
        600: 106,
        700: 121,
        800: 132,
        900: 146,
        1000: 157,
        1100: 167,
        1200: 183,
        1300: 193,
        1400: 203,
        1500: 216,
        1600: 226,
      },
      1200: {
        400: 95,
        500: 101,
        600: 110,
        700: 126,
        800: 137,
        900: 152,
        1000: 163,
        1100: 174,
        1200: 190,
        1300: 201,
        1400: 212,
        1500: 224,
        1600: 236,
      },
      1300: {
        400: 99,
        500: 105,
        600: 115,
        700: 131,
        800: 142,
        900: 156,
        1000: 169,
        1100: 181,
        1200: 197,
        1300: 209,
        1400: 220,
        1500: 233,
        1600: 254,
      },
      1400: {
        400: 104,
        500: 109,
        600: 119,
        700: 136,
        800: 148,
        900: 163,
        1000: 175,
        1100: 187,
        1200: 204,
        1300: 216,
        1400: 227,
        1500: 243,
        1600: 255,
      },
      1500: {
        400: 106,
        500: 113,
        600: 123,
        700: 140,
        800: 152,
        900: 169,
        1000: 181,
        1100: 194,
        1200: 212,
        1300: 225,
        1400: 238,
        1500: 251,
        1600: 265,
      },
      1600: {
        400: 109,
        500: 115,
        600: 127,
        700: 144,
        800: 158,
        900: 174,
        1000: 188,
        1100: 200,
        1200: 219,
        1300: 232,
        1400: 244,
        1500: 260,
        1600: 273,
      },
      1700: {
        400: 113,
        500: 119,
        600: 131,
        700: 149,
        800: 162,
        900: 180,
        1000: 193,
        1100: 206,
        1200: 225,
        1300: 240,
        1400: 250,
        1500: 267,
        1600: 282,
      },
      1800: {
        400: 116,
        500: 122,
        600: 135,
        700: 153,
        800: 168,
        900: 185,
        1000: 198,
        1100: 213,
        1200: 233,
        1300: 247,
        1400: 261,
        1500: 277,
        1600: 292,
      },
      1900: {
        400: 118,
        500: 126,
        600: 139,
        700: 158,
        800: 173,
        900: 190,
        1000: 205,
        1100: 219,
        1200: 239,
        1300: 255,
        1400: 270,
        1500: 285,
        1600: 301,
      },
      2000: {
        400: 121,
        500: 129,
        600: 143,
        700: 162,
        800: 178,
        900: 195,
        1000: 211,
        1100: 226,
        1200: 248,
        1300: 262,
        1400: 278,
        1500: 294,
        1600: 309,
      },
      2100: {
        400: 125,
        500: 133,
        600: 148,
        700: 167,
        800: 183,
        900: 201,
        1000: 218,
        1100: 233,
        1200: 254,
        1300: 270,
        1400: 285,
        1500: 302,
        1600: 320,
      },
      2200: {
        400: 128,
        500: 136,
        600: 151,
        700: 172,
        800: 188,
        900: 207,
        1000: 223,
        1100: 239,
        1200: 260,
        1300: 278,
        1400: 294,
        1500: 312,
        1600: 328,
      },
      2300: {
        400: 132,
        500: 140,
        600: 156,
        700: 177,
        800: 193,
        900: 212,
        1000: 229,
        1100: 247,
        1200: 269,
        1300: 284,
        1400: 302,
        1500: 321,
        1600: 338,
      },
      2400: {
        400: 135,
        500: 143,
        600: 160,
        700: 181,
        800: 199,
        900: 217,
        1000: 236,
        1100: 253,
        1200: 276,
        1300: 293,
        1400: 311,
        1500: 329,
        1600: 345,
      },
    },
    1: {
      700: {
        400: 93,
        500: 100,
        600: 110,
        700: 125,
        800: 141,
        900: 152,
        1000: 178,
        1100: 189,
        1200: 204,
        1300: 220,
        1400: 235,
        1500: 251,
        1600: 265,
      },
      800: {
        400: 87,
        500: 94,
        600: 104,
        700: 116,
        800: 132,
        900: 147,
        1000: 160,
        1100: 171,
        1200: 182,
        1300: 193,
        1400: 203,
        1500: 215,
        1600: 226,
      },
      900: {
        400: 92,
        500: 98,
        600: 109,
        700: 121,
        800: 139,
        900: 155,
        1000: 167,
        1100: 179,
        1200: 192,
        1300: 204,
        1400: 215,
        1500: 227,
        1600: 239,
      },
      1000: {
        400: 95,
        500: 102,
        600: 115,
        700: 128,
        800: 145,
        900: 163,
        1000: 175,
        1100: 189,
        1200: 200,
        1300: 214,
        1400: 227,
        1500: 239,
        1600: 252,
      },
      1100: {
        400: 100,
        500: 107,
        600: 120,
        700: 133,
        800: 152,
        900: 170,
        1000: 183,
        1100: 197,
        1200: 211,
        1300: 223,
        1400: 238,
        1500: 252,
        1600: 264,
      },
      1200: {
        400: 104,
        500: 112,
        600: 125,
        700: 139,
        800: 159,
        900: 177,
        1000: 191,
        1100: 206,
        1200: 220,
        1300: 235,
        1400: 250,
        1500: 263,
        1600: 277,
      },
      1300: {
        400: 109,
        500: 115,
        600: 131,
        700: 145,
        800: 167,
        900: 184,
        1000: 198,
        1100: 215,
        1200: 231,
        1300: 244,
        1400: 261,
        1500: 275,
        1600: 291,
      },
      1400: {
        400: 113,
        500: 121,
        600: 135,
        700: 151,
        800: 173,
        900: 192,
        1000: 208,
        1100: 224,
        1200: 240,
        1300: 259,
        1400: 272,
        1500: 286,
        1600: 303,
      },
      1500: {
        400: 118,
        500: 126,
        600: 141,
        700: 158,
        800: 182,
        900: 199,
        1000: 220,
        1100: 236,
        1200: 248,
        1300: 271,
        1400: 284,
        1500: 300,
        1600: 313,
      },
      1600: {
        400: 122,
        500: 130,
        600: 147,
        700: 165,
        800: 187,
        900: 207,
        1000: 228,
        1100: 241,
        1200: 259,
        1300: 277,
        1400: 293,
        1500: 310,
        1600: 328,
      },
      1700: {
        400: 127,
        500: 135,
        600: 152,
        700: 172,
        800: 196,
        900: 215,
        1000: 237,
        1100: 250,
        1200: 270,
        1300: 288,
        1400: 306,
        1500: 324,
        1600: 342,
      },
      1800: {
        400: 130,
        500: 139,
        600: 158,
        700: 175,
        800: 200,
        900: 221,
        1000: 244,
        1100: 258,
        1200: 280,
        1300: 298,
        1400: 318,
        1500: 335,
        1600: 352,
      },
      1900: {
        400: 135,
        500: 145,
        600: 162,
        700: 181,
        800: 208,
        900: 229,
        1000: 248,
        1100: 269,
        1200: 288,
        1300: 307,
        1400: 328,
        1500: 347,
        1600: 366,
      },
      2000: {
        400: 139,
        500: 149,
        600: 168,
        700: 188,
        800: 215,
        900: 237,
        1000: 256,
        1100: 278,
        1200: 299,
        1300: 319,
        1400: 340,
        1500: 360,
        1600: 379,
      },
      2100: {
        400: 144,
        500: 152,
        600: 174,
        700: 193,
        800: 221,
        900: 243,
        1000: 262,
        1100: 287,
        1200: 309,
        1300: 328,
        1400: 352,
        1500: 371,
        1600: 390,
      },
      2200: {
        400: 148,
        500: 158,
        600: 179,
        700: 199,
        800: 228,
        900: 251,
        1000: 271,
        1100: 295,
        1200: 318,
        1300: 339,
        1400: 362,
        1500: 382,
        1600: 403,
      },
      2300: {
        400: 151,
        500: 162,
        600: 185,
        700: 206,
        800: 235,
        900: 257,
        1000: 278,
        1100: 302,
        1200: 329,
        1300: 349,
        1400: 375,
        1500: 398,
        1600: 417,
      },
      2400: {
        400: 157,
        500: 168,
        600: 189,
        700: 211,
        800: 242,
        900: 266,
        1000: 288,
        1100: 312,
        1200: 338,
        1300: 359,
        1400: 385,
        1500: 407,
        1600: 429,
      },
    },
    2: {
      700: {
        400: 102,
        500: 109,
        600: 124,
        700: 140,
        800: 151,
        900: 177,
        1000: 188,
        1100: 203,
        1200: 219,
        1300: 234,
        1400: 250,
        1500: 264,
        1600: 282,
      },
      800: {
        400: 97,
        500: 103,
        600: 115,
        700: 131,
        800: 146,
        900: 163,
        1000: 180,
        1100: 191,
        1200: 207,
        1300: 218,
        1400: 235,
        1500: 245,
        1600: 263,
      },
      900: {
        400: 102,
        500: 109,
        600: 121,
        700: 139,
        800: 155,
        900: 173,
        1000: 191,
        1100: 203,
        1200: 220,
        1300: 232,
        1400: 250,
        1500: 262,
        1600: 280,
      },
      1000: {
        400: 108,
        500: 114,
        600: 129,
        700: 147,
        800: 164,
        900: 183,
        1000: 201,
        1100: 214,
        1200: 233,
        1300: 246,
        1400: 263,
        1500: 277,
        1600: 296,
      },
      1100: {
        400: 113,
        500: 121,
        600: 135,
        700: 154,
        800: 173,
        900: 193,
        1000: 212,
        1100: 225,
        1200: 245,
        1300: 260,
        1400: 279,
        1500: 293,
        1600: 313,
      },
      1200: {
        400: 119,
        500: 127,
        600: 142,
        700: 162,
        800: 182,
        900: 202,
        1000: 222,
        1100: 238,
        1200: 258,
        1300: 274,
        1400: 293,
        1500: 309,
        1600: 329,
      },
      1300: {
        400: 125,
        500: 134,
        600: 150,
        700: 171,
        800: 191,
        900: 212,
        1000: 233,
        1100: 249,
        1200: 271,
        1300: 288,
        1400: 308,
        1500: 324,
        1600: 345,
      },
      1400: {
        400: 130,
        500: 139,
        600: 157,
        700: 179,
        800: 200,
        900: 222,
        1000: 243,
        1100: 259,
        1200: 282,
        1300: 300,
        1400: 323,
        1500: 341,
        1600: 362,
      },
      1500: {
        400: 136,
        500: 145,
        600: 165,
        700: 187,
        800: 209,
        900: 232,
        1000: 255,
        1100: 272,
        1200: 296,
        1300: 314,
        1400: 338,
        1500: 357,
        1600: 380,
      },
      1600: {
        400: 141,
        500: 150,
        600: 171,
        700: 195,
        800: 221,
        900: 239,
        1000: 264,
        1100: 282,
        1200: 304,
        1300: 326,
        1400: 349,
        1500: 372,
        1600: 394,
      },
      1700: {
        400: 147,
        500: 157,
        600: 178,
        700: 203,
        800: 230,
        900: 248,
        1000: 275,
        1100: 292,
        1200: 316,
        1300: 338,
        1400: 363,
        1500: 387,
        1600: 410,
      },
      1800: {
        400: 152,
        500: 163,
        600: 186,
        700: 210,
        800: 236,
        900: 257,
        1000: 285,
        1100: 302,
        1200: 327,
        1300: 349,
        1400: 375,
        1500: 400,
        1600: 424,
      },
      1900: {
        400: 158,
        500: 169,
        600: 192,
        700: 219,
        800: 245,
        900: 267,
        1000: 294,
        1100: 312,
        1200: 336,
        1300: 360,
        1400: 386,
        1500: 410,
        1600: 435,
      },
      2000: {
        400: 163,
        500: 175,
        600: 199,
        700: 227,
        800: 254,
        900: 277,
        1000: 304,
        1100: 323,
        1200: 347,
        1300: 371,
        1400: 397,
        1500: 421,
        1600: 446,
      },
      2100: {
        400: 169,
        500: 181,
        600: 207,
        700: 234,
        800: 263,
        900: 290,
        1000: 317,
        1100: 340,
        1200: 373,
        1300: 398,
        1400: 425,
        1500: 451,
        1600: 478,
      },
      2200: {
        400: 175,
        500: 187,
        600: 214,
        700: 243,
        800: 272,
        900: 299,
        1000: 329,
        1100: 353,
        1200: 384,
        1300: 411,
        1400: 439,
        1500: 466,
        1600: 495,
      },
      2300: {
        400: 180,
        500: 193,
        600: 221,
        700: 250,
        800: 279,
        900: 310,
        1000: 339,
        1100: 364,
        1200: 397,
        1300: 425,
        1400: 454,
        1500: 483,
        1600: 512,
      },
      2400: {
        400: 186,
        500: 199,
        600: 228,
        700: 258,
        800: 289,
        900: 319,
        1000: 351,
        1100: 376,
        1200: 410,
        1300: 438,
        1400: 470,
        1500: 500,
        1600: 529,
      },
    },
    3: {
      700: {
        400: 117,
        500: 125,
        600: 142,
        700: 160,
        800: 172,
        900: 202,
        1000: 214,
        1100: 231,
        1200: 250,
        1300: 266,
        1400: 284,
        1500: 301,
        1600: 320,
      },
      800: {
        400: 106,
        500: 114,
        600: 130,
        700: 145,
        800: 158,
        900: 184,
        1000: 195,
        1100: 211,
        1200: 227,
        1300: 243,
        1400: 261,
        1500: 277,
        1600: 293,
      },
      900: {
        400: 113,
        500: 120,
        600: 138,
        700: 154,
        800: 169,
        900: 195,
        1000: 209,
        1100: 225,
        1200: 243,
        1300: 260,
        1400: 279,
        1500: 296,
        1600: 314,
      },
      1000: {
        400: 119,
        500: 128,
        600: 147,
        700: 166,
        800: 180,
        900: 208,
        1000: 222,
        1100: 239,
        1200: 259,
        1300: 279,
        1400: 298,
        1500: 316,
        1600: 334,
      },
      1100: {
        400: 126,
        500: 134,
        600: 153,
        700: 175,
        800: 191,
        900: 218,
        1000: 236,
        1100: 254,
        1200: 276,
        1300: 295,
        1400: 315,
        1500: 335,
        1600: 355,
      },
      1200: {
        400: 133,
        500: 141,
        600: 163,
        700: 186,
        800: 201,
        900: 231,
        1000: 249,
        1100: 269,
        1200: 292,
        1300: 312,
        1400: 333,
        1500: 356,
        1600: 377,
      },
      1300: {
        400: 139,
        500: 149,
        600: 172,
        700: 195,
        800: 212,
        900: 242,
        1000: 261,
        1100: 282,
        1200: 308,
        1300: 330,
        1400: 352,
        1500: 375,
        1600: 397,
      },
      1400: {
        400: 145,
        500: 156,
        600: 180,
        700: 205,
        800: 223,
        900: 254,
        1000: 276,
        1100: 298,
        1200: 322,
        1300: 346,
        1400: 369,
        1500: 395,
        1600: 418,
      },
      1500: {
        400: 151,
        500: 164,
        600: 189,
        700: 215,
        800: 235,
        900: 267,
        1000: 288,
        1100: 312,
        1200: 334,
        1300: 361,
        1400: 386,
        1500: 413,
        1600: 438,
      },
      1600: {
        400: 158,
        500: 170,
        600: 197,
        700: 225,
        800: 246,
        900: 277,
        1000: 300,
        1100: 326,
        1200: 356,
        1300: 380,
        1400: 406,
        1500: 433,
        1600: 459,
      },
      1700: {
        400: 165,
        500: 177,
        600: 206,
        700: 234,
        800: 257,
        900: 289,
        1000: 312,
        1100: 340,
        1200: 368,
        1300: 399,
        1400: 425,
        1500: 453,
        1600: 480,
      },
      1800: {
        400: 172,
        500: 185,
        600: 214,
        700: 244,
        800: 268,
        900: 300,
        1000: 325,
        1100: 354,
        1200: 379,
        1300: 417,
        1400: 444,
        1500: 472,
        1600: 501,
      },
      1900: {
        400: 178,
        500: 191,
        600: 222,
        700: 253,
        800: 278,
        900: 311,
        1000: 337,
        1100: 367,
        1200: 393,
        1300: 435,
        1400: 463,
        1500: 491,
        1600: 521,
      },
      2000: {
        400: 183,
        500: 197,
        600: 230,
        700: 262,
        800: 289,
        900: 322,
        1000: 350,
        1100: 380,
        1200: 407,
        1300: 454,
        1400: 482,
        1500: 510,
        1600: 541,
      },
      2100: {
        400: 192,
        500: 206,
        600: 239,
        700: 274,
        800: 301,
        900: 336,
        1000: 367,
        1100: 398,
        1200: 436,
        1300: 466,
        1400: 496,
        1500: 531,
        1600: 561,
      },
      2200: {
        400: 198,
        500: 213,
        600: 248,
        700: 283,
        800: 313,
        900: 350,
        1000: 381,
        1100: 414,
        1200: 451,
        1300: 483,
        1400: 515,
        1500: 550,
        1600: 581,
      },
      2300: {
        400: 205,
        500: 220,
        600: 255,
        700: 293,
        800: 323,
        900: 360,
        1000: 395,
        1100: 428,
        1200: 468,
        1300: 500,
        1400: 533,
        1500: 570,
        1600: 602,
      },
      2400: {
        400: 212,
        500: 227,
        600: 265,
        700: 303,
        800: 334,
        900: 373,
        1000: 408,
        1100: 442,
        1200: 483,
        1300: 517,
        1400: 552,
        1500: 589,
        1600: 622,
      },
    },

    4: {
      700: {
        400: 129,
        500: 138,
        600: 155,
        700: 175,
        800: 189,
        900: 219,
        1000: 233,
        1100: 251,
        1200: 272,
        1300: 291,
        1400: 309,
        1500: 329,
        1600: 350,
      },
      800: {
        400: 121,
        500: 130,
        600: 149,
        700: 166,
        800: 180,
        900: 210,
        1000: 224,
        1100: 240,
        1200: 259,
        1300: 278,
        1400: 298,
        1500: 317,
        1600: 334,
      },
      900: {
        400: 129,
        500: 137,
        600: 157,
        700: 177,
        800: 193,
        900: 224,
        1000: 240,
        1100: 257,
        1200: 278,
        1300: 297,
        1400: 318,
        1500: 338,
        1600: 359,
      },
      1000: {
        400: 136,
        500: 146,
        600: 168,
        700: 189,
        800: 205,
        900: 237,
        1000: 253,
        1100: 273,
        1200: 296,
        1300: 319,
        1400: 340,
        1500: 361,
        1600: 382,
      },
      1100: {
        400: 144,
        500: 154,
        600: 176,
        700: 200,
        800: 218,
        900: 250,
        1000: 270,
        1100: 291,
        1200: 315,
        1300: 338,
        1400: 361,
        1500: 384,
        1600: 406,
      },
      1200: {
        400: 153,
        500: 162,
        600: 187,
        700: 212,
        800: 230,
        900: 265,
        1000: 285,
        1100: 308,
        1200: 334,
        1300: 357,
        1400: 381,
        1500: 406,
        1600: 430,
      },
      1300: {
        400: 159,
        500: 171,
        600: 198,
        700: 223,
        800: 243,
        900: 277,
        1000: 299,
        1100: 323,
        1200: 352,
        1300: 377,
        1400: 402,
        1500: 428,
        1600: 453,
      },
      1400: {
        400: 166,
        500: 178,
        600: 206,
        700: 234,
        800: 255,
        900: 291,
        1000: 316,
        1100: 341,
        1200: 370,
        1300: 396,
        1400: 423,
        1500: 451,
        1600: 478,
      },
      1500: {
        400: 174,
        500: 187,
        600: 217,
        700: 246,
        800: 269,
        900: 306,
        1000: 331,
        1100: 358,
        1200: 384,
        1300: 414,
        1400: 442,
        1500: 472,
        1600: 501,
      },
      1600: {
        400: 181,
        500: 196,
        600: 225,
        700: 257,
        800: 282,
        900: 318,
        1000: 345,
        1100: 374,
        1200: 408,
        1300: 436,
        1400: 466,
        1500: 497,
        1600: 527,
      },
      1700: {
        400: 189,
        500: 202,
        600: 235,
        700: 268,
        800: 293,
        900: 332,
        1000: 360,
        1100: 392,
        1200: 427,
        1300: 457,
        1400: 489,
        1500: 522,
        1600: 554,
      },
      1800: {
        400: 197,
        500: 211,
        600: 246,
        700: 281,
        800: 309,
        900: 348,
        1000: 377,
        1100: 410,
        1200: 447,
        1300: 479,
        1400: 512,
        1500: 547,
        1600: 581,
      },
      1900: {
        400: 204,
        500: 220,
        600: 255,
        700: 293,
        800: 323,
        900: 360,
        1000: 395,
        1100: 428,
        1200: 468,
        1300: 500,
        1400: 533,
        1500: 570,
        1600: 602,
      },
      2000: {
        400: 210,
        500: 226,
        600: 263,
        700: 301,
        800: 331,
        900: 369,
        1000: 401,
        1100: 436,
        1200: 474,
        1300: 507,
        1400: 541,
        1500: 578,
        1600: 614,
      },
      2100: {
        400: 220,
        500: 236,
        600: 274,
        700: 314,
        800: 344,
        900: 385,
        1000: 421,
        1100: 457,
        1200: 500,
        1300: 534,
        1400: 569,
        1500: 609,
        1600: 643,
      },
      2200: {
        400: 227,
        500: 244,
        600: 285,
        700: 324,
        800: 358,
        900: 400,
        1000: 437,
        1100: 475,
        1200: 518,
        1300: 553,
        1400: 591,
        1500: 630,
        1600: 666,
      },
      2300: {
        400: 235,
        500: 252,
        600: 293,
        700: 336,
        800: 371,
        900: 413,
        1000: 453,
        1100: 490,
        1200: 536,
        1300: 572,
        1400: 611,
        1500: 653,
        1600: 691,
      },
      2400: {
        400: 243,
        500: 261,
        600: 304,
        700: 347,
        800: 383,
        900: 427,
        1000: 467,
        1100: 507,
        1200: 553,
        1300: 593,
        1400: 633,
        1500: 675,
        1600: 714,
      },
    },
  },
};

document.addEventListener("DOMContentLoaded", function () {
  const config = window.BasicProductConfig;
  let selectedFabricGroup = null;
  let selectedProfile = null;
  let widthInput, heightInput, profileStep, priceDisplay, calculatedPrice;

  let lastValues = {
    width: "",
    height: "",
    fabric: "",
    profile: "",
  };

  // Piilota alkuperäinen ostoskoriin-nappi heti
  setTimeout(function () {
    const originalButton = document.querySelector('button[name="add"]');

    if (originalButton) {
      originalButton.style.position = "absolute";
      originalButton.style.left = "-9999px";
      originalButton.style.visibility = "hidden";
      console.log("Original button hidden on page load");
    }
  }, 100);

  // Odota että DOM on valmis, sitten luo elementit
  setTimeout(function () {
    console.log("Calling createBasicElements...");
    createBasicElements();

    // Tunnista oletuskangasväri sivun latautuessa
    const fabricSelect = document.querySelector(
      'select[name="options[KANGAS]"]'
    );
    if (fabricSelect && fabricSelect.selectedIndex >= 0) {
      const selectedOption = fabricSelect.options[fabricSelect.selectedIndex];
      const variantTitle = selectedOption.text;
      const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
      if (groupMatch) {
        selectedFabricGroup = groupMatch[1];
        console.log("Initial fabric group detected:", selectedFabricGroup);

        if (profileStep) {
          profileStep.classList.remove("disabled");
          profileStep.classList.add("active");
          createProfileOptions();
        }
      }
    }

    // Kangasvärin valinta
    if (fabricSelect) {
      fabricSelect.addEventListener("change", function () {
        const selectedOption = this.options[this.selectedIndex];
        const variantTitle = selectedOption.text;

        const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
        if (groupMatch) {
          selectedFabricGroup = groupMatch[1];
          console.log("Selected fabric group:", selectedFabricGroup);

          if (profileStep) {
            profileStep.classList.remove("disabled");
            profileStep.classList.add("active");
            createProfileOptions();
          }
          calculatePrice();
        }
      });
    }
  }, 300);

  function createBasicElements() {
  const productForm =
    document.querySelector(".product-form") ||
    document.querySelector(".product__info-wrapper") ||
    document.body;

  // Luo pääkontaineri
  let configurator = document.getElementById("basic-configurator");
  if (!configurator) {
    configurator = document.createElement("div");
    configurator.id = "basic-configurator";
    configurator.className = "slim-configurator";
    productForm.appendChild(configurator);
  }

    // Luo mittakentät
    if (!document.getElementById("width-input")) {
      const dimensionsDiv = document.createElement("div");
      dimensionsDiv.className = "config-step active";

      dimensionsDiv.innerHTML = `
            <h3>Syötä mitat (mm)</h3>
            <div class="dimension-inputs">
                <div class="input-group">
                    <label>Leveys</label>
                    <input placeholder="esim. 1000" max="1500" min="200" id="width-input" type="number">
                    <div id="width-validation" class="validation-message"></div>
                </div>
                <div class="input-group">
                    <label>Korkeus</label>
                    <input placeholder="esim. 1500" max="2200" min="200" id="height-input" type="number">
                    <div id="height-validation" class="validation-message"></div>
                </div>
            </div>
        `;

      configurator.appendChild(dimensionsDiv);
    }

    // Luo profiiliväri-osio
    if (!document.getElementById("profile-step")) {
      const profileDiv = document.createElement("div");
      profileDiv.id = "profile-step";
      profileDiv.className = "config-step disabled";
      profileDiv.innerHTML = `
            <h3>Valitse profiiliväri</h3>
            <div id="profile-options"></div>
        `;
      configurator.appendChild(profileDiv);
    }

    // Luo hinta-osio
    if (!document.getElementById("price-display")) {
      const priceDiv = document.createElement("div");
      priceDiv.id = "price-display";
      priceDiv.className = "config-step price-display";
      priceDiv.style.display = "none";
      priceDiv.innerHTML = `
            <h3>Hinta</h3>
            <div style="font-size: 2rem; font-weight: bold; color: #ffffff; margin-bottom: 15px;" id="calculated-price"></div>
        `;
      configurator.appendChild(priceDiv);
    }

    // Päivitä elementtiviittaukset
    widthInput = document.getElementById("width-input");
    heightInput = document.getElementById("height-input");
    profileStep = document.getElementById("profile-step");
    priceDisplay = document.getElementById("price-display");
    calculatedPrice = document.getElementById("calculated-price");
  }

  function getProfilesForProduct() {
    const productHandle = window.location.pathname;

    // Jos ALL-BLACK tai MUSTA tuote - vain musta profiili
    if (
      productHandle.includes("all-black") ||
      productHandle.includes("musta")
    ) {
      return {
        anthracite: {
          name: "Musta RAL9005 structure",
          color: "#0A0A0A",
        },
      };
    }

    // Muuten kaikki normaalit BASIC profiilit
    return config.profiles;
  }

  function createProfileOptions() {
    const profileOptions = document.getElementById("profile-options");
    if (!profileOptions) return;

    const customDropdown = document.createElement("div");
    customDropdown.className = "custom-dropdown";

    const selected = document.createElement("div");
    selected.className = "dropdown-selected";

    selected.innerHTML = `
    <span>Valitse profiiliväri</span>
    <span class="dropdown-arrow">▼</span>
  `;

    const options = document.createElement("div");
    options.className = "dropdown-options";

    // Lisää profiilivärit
    Object.keys(getProfilesForProduct()).forEach(function (key) {
      const profile = getProfilesForProduct()[key];

      const option = document.createElement("div");
      option.className = "dropdown-option";

      option.innerHTML = `
      <span style="background-color: ${profile.color};" class="profile-color-icon"></span>
      <span class="profile-option-text">${profile.name}</span>
    `;

      option.addEventListener("click", function () {
        console.log("CLICKED:", profile.name);
        selectedProfile = key;
        selected.innerHTML = `
        <span class="dropdown-selected-content">
          <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
          ${profile.name}
        </span>
        <span class="dropdown-arrow">▼</span>
      `;

        options.classList.remove("show");
        calculatePrice();
      });

      options.appendChild(option);
    });

    selected.addEventListener("click", function () {
      options.classList.toggle("show");
    });

    customDropdown.appendChild(selected);
    customDropdown.appendChild(options);

    profileOptions.innerHTML = "";
    profileOptions.appendChild(customDropdown);
  }

  function calculatePrice() {
    console.log("calculatePrice called");
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    // Tarkista validointi ensin
    if (!updateFieldValidation()) {
      console.log("Validation failed");
      // Näytä lähtöhinta vaikka validointi epäonnistui (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 130.00 €";
      return;
    }

    // Tarkista että profiiliväri on valittu
    if (!selectedProfile) {
      console.log("No profile selected");
      // Näytä lähtöhinta vaikka profiilia ei valittu (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 130.00 €";
      return;
    }

    console.log("Current values:", {
      width: width,
      height: height,
      selectedFabricGroup: selectedFabricGroup,
      selectedProfile: selectedProfile,
    });

    if (
      width > 0 &&
      height > 0 &&
      selectedFabricGroup &&
      config.priceTable[selectedFabricGroup]
    ) {
      const normalizedWidth = Math.min(
        Math.max(Math.ceil(width / 100) * 100, 400),
        1500
      );
      const normalizedHeight = Math.min(
        Math.max(Math.ceil(height / 100) * 100, 700),
        2400
      );

      console.log(
        "Normalized dimensions:",
        normalizedWidth,
        "x",
        normalizedHeight
      );

      const priceData = config.priceTable[selectedFabricGroup];
      let basePrice = null;

      if (priceData[normalizedHeight]) {
        if (priceData[normalizedHeight][normalizedWidth]) {
          basePrice = priceData[normalizedHeight][normalizedWidth];
          console.log("Price found:", basePrice);
        } else {
          // B-hinnoittelu: etsi lähin pienempi leveys
          for (let w = normalizedWidth - 100; w >= 400; w -= 100) {
            if (priceData[normalizedHeight][w]) {
              basePrice = priceData[normalizedHeight][w];
              console.log("B-pricing: Found price", basePrice, "at width", w);
              break;
            }
          }
          if (!basePrice) basePrice = 74.0;
        }
      } else {
        // B-hinnoittelu: etsi lähin pienempi korkeus
        for (let h = normalizedHeight - 100; h >= 700; h -= 100) {
          if (priceData[h] && priceData[h][normalizedWidth]) {
            basePrice = priceData[h][normalizedWidth];
            console.log("B-pricing: Found price", basePrice, "at height", h);
            break;
          }
        }
        if (!basePrice) basePrice = 74.0;
      }

      if (calculatedPrice && basePrice) {
        // 1. Lisää euromääräinen muutos
        let priceAfterEuro = basePrice + PRICE_ADJUSTMENTS.euroAdjustment;
        console.log("After euro adjustment:", priceAfterEuro);
        
        // 2. Lisää prosentuaalinen muutos
        let priceAfterPercent = priceAfterEuro * (1 + PRICE_ADJUSTMENTS.percentAdjustment / 100);
        console.log("After percent adjustment:", priceAfterPercent);
        
        // 3. Pyöristä lähimpään tasaeuroon
        let roundedPrice = Math.round(priceAfterPercent);
        console.log("After rounding:", roundedPrice);
        
        // 4. Varmista minimihinta 130 €
        const finalPrice = Math.max(roundedPrice, 130);
        console.log("Final price:", finalPrice);
        
        calculatedPrice.textContent = finalPrice.toFixed(2) + " €";
      }
      if (priceDisplay) {
        priceDisplay.style.display = "block";
      }

      // Lisää ostoskoriin-nappi
      createAddToCartButton();
    } else {
      console.log("Conditions not met for price calculation");
      if (priceDisplay) priceDisplay.style.display = "none";
    }
  }

  function validateDimensions(width, height) {
    const errors = {};
    const messages = {};

    if (width < 200) {
      errors.width = true;
      messages.width = "Min 200mm";
    } else if (width > 1500) {
      errors.width = true;
      messages.width = "Max 1500mm";
    }

    if (height < 200) {
      errors.height = true;
      messages.height = "Min 200mm";
    } else if (height > 2200) {
      errors.height = true;
      messages.height = "Max 2200mm";
    }

    if (width * height > 2600000) {
      errors.width = true;
      errors.height = true;
      messages.width = "Max 2,6 m²";
      messages.height = "Max 2,6 m²";
    }

    if (width >= 201 && width <= 1200 && height > 2200) {
      errors.height = true;
      messages.height = "Max 2200mm";
    }
    if (width >= 1201 && width <= 1500 && height > 1600) {
      errors.height = true;
      messages.height = "Max 1600mm";
    }

    return { errors, messages };
  }

  function updateFieldValidation() {
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    if (width > 0 && height > 0) {
      const validation = validateDimensions(width, height);

      // Käytä CSS-luokkia inline-tyylien sijaan
      const widthValidation = document.getElementById("width-validation");
      const heightValidation = document.getElementById("height-validation");

      if (validation.errors.width) {
        widthInput.style.borderColor = "#ff6b6b";
        if (widthValidation) {
          widthValidation.textContent = validation.messages.width;
          widthValidation.className = "validation-message error";
        }
      } else {
        widthInput.style.borderColor = "#333";
        if (widthValidation) {
          widthValidation.textContent = "";
          widthValidation.className = "validation-message";
        }
      }

      if (validation.errors.height) {
        heightInput.style.borderColor = "#ff6b6b";
        if (heightValidation) {
          heightValidation.textContent = validation.messages.height;
          heightValidation.className = "validation-message error";
        }
      } else {
        heightInput.style.borderColor = "#333";
        if (heightValidation) {
          heightValidation.textContent = "";
          heightValidation.className = "validation-message";
        }
      }

      if (validation.errors.width || validation.errors.height) {
        if (priceDisplay) priceDisplay.style.display = "none";
        return false;
      }
    }

    return true;
  }

    function createAddToCartButton() {
    // Tarkista onko nappi jo olemassa
    let existingButton = document.getElementById("basic-add-to-cart");
    if (existingButton) {
      existingButton.style.display = "block";
      return;
    }

    // Luo uusi nappi
    const addToCartButton = document.createElement("button");
    addToCartButton.id = "basic-add-to-cart";
    addToCartButton.type = "button";
    addToCartButton.textContent = "Lisää ostoskoriin";
    addToCartButton.className = "basic-add-to-cart-button";

    // UUSI: Cart API -pohjainen lisäys
    addToCartButton.addEventListener("click", function () {
  // Kerää tiedot
  const width = parseInt(widthInput.value);
  const height = parseInt(heightInput.value);
  const calculatedPriceValue = parseFloat(calculatedPrice.textContent.replace(' €', '').replace(',', '.'));
  const profileName = getProfilesForProduct()[selectedProfile].name;
  
  // Hae kangasväri
  const fabricSelect = document.querySelector('select[name="options[KANGAS]"]');
  const fabricOption = fabricSelect ? fabricSelect.options[fabricSelect.selectedIndex].text : 'Ei valittu';
  
  // Perustuotteen hinta
  const basePrice = 130.00;
  
  // Laske korotus
  const priceAdjustment = calculatedPriceValue - basePrice;
  
  // Luo unique ID tälle tuoteparille
  const pairId = Date.now().toString();
  
    // Valmistele Cart API -kutsu (käänteisessä järjestyksessä)
  const formData = {
    items: []
  };
  
  // Jos korotus > 0, lisää hintakorjaustuote ENSIN
  if (priceAdjustment > 0) {
    const adjustmentQuantity = Math.round(priceAdjustment);
    
    formData.items.push({
      id: config.variantIds.adjustment,
      quantity: adjustmentQuantity,
      properties: {
        'Kangasväri': fabricOption,
        'Mitat': `${width}×${height} mm`,
        'Profiiliväri': profileName,
        '_pair_id': pairId,
        '_pair_order': '2'
      }
    });
  }
  
    // Lisää perustuote TOISENA
  formData.items.push({
    id: config.variantIds.base,
    quantity: 1,
    properties: {
      '_pair_id': pairId,
      '_pair_order': '1'
    }
  });
  
  // Lähetä Cart API:lle
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    window.location.href = '/cart';
  })
  .catch((error) => {
    console.error('Error:', error);
    alert('Lisääminen ostoskoriin epäonnistui. Yritä uudelleen.');
  });
});

    // Lisää hinta-osion jälkeen
    if (priceDisplay) {
      priceDisplay.appendChild(addToCartButton);
    }
    
    console.log("Add to cart button created");
  }

  function checkForChanges() {
    const currentWidth = widthInput?.value || "";
    const currentHeight = heightInput?.value || "";
    const currentFabric =
      document.querySelector('select[name="options[KANGAS]"]')?.value || "";
    const currentProfile = selectedProfile || "";

    if (
      currentWidth !== lastValues.width ||
      currentHeight !== lastValues.height ||
      currentFabric !== lastValues.fabric ||
      currentProfile !== lastValues.profile
    ) {
      console.log("Change detected, updating price...");

      // Päivitä kangasryhmä jos tarpeen
      if (currentFabric !== lastValues.fabric) {
        const fabricSelect = document.querySelector(
          'select[name="options[KANGAS]"]'
        );
        if (fabricSelect) {
          const selectedOption =
            fabricSelect.options[fabricSelect.selectedIndex];
          const variantTitle = selectedOption.text;
          const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
          if (groupMatch) {
            selectedFabricGroup = groupMatch[1];
            console.log("Updated fabric group:", selectedFabricGroup);
          }
        }
      }

      calculatePrice();

      lastValues.width = currentWidth;
      lastValues.height = currentHeight;
      lastValues.fabric = currentFabric;
      lastValues.profile = currentProfile;
    }
  }

  function updateAreaDisplay(width, height) {
    console.log("updateAreaDisplay called with:", width, height);

    const areaValueElement = document.getElementById("area-value");
    const areaDisplayElement = document.getElementById("area-display");

    console.log("Area value element:", areaValueElement);
    console.log("Area display element:", areaDisplayElement);

    if (!areaValueElement) {
      console.log("ERROR: area-value element not found!");
      return;
    }

    if (width > 0 && height > 0) {
      const area = ((width * height) / 1000000).toFixed(2);
      console.log("Calculated area:", area);

      areaValueElement.textContent = area + " m²";
      console.log("Area text updated to:", areaValueElement.textContent);

      // Muuta väri jos ylittää 2,6 m²
      if (parseFloat(area) > 2.6) {
        areaValueElement.style.color = "red";
        console.log("Area color set to red");
      } else {
        areaValueElement.style.color = "#dfa408";
        console.log("Area color set to green");
      }
    } else {
      areaValueElement.textContent = "- m²";
      areaValueElement.style.color = "white";
      console.log("Area reset to default");
    }
  }

  // Tarkista muutokset 500ms välein
  setInterval(checkForChanges, 500);
});
